export const LOADING = "LOADING";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const SHOW_CART_NOTIFICATION = "SHOW_CART_NOTIFICATION";
export const CLOSE_CART_NOTIFICATiON = "CLOSE_CART_NOTIFICATION";
export const SHOW_LOGIN = "SHOW_LOGIN";
export const SET_AUTH_POPUP_PANEL = "SET_AUTH_POPUP_PANEL";
export const SHOW_RESPONSIVE_MENU = "SHOW_RESPONSIVE_MENU";
export const MAIN_LOCK_SCROLL = "MAIN_LOCK_SCROLL";
export const WEB_STATUS = "WEB_STATUS";
export const WEB_STATUS_ERR = "WEB_STATUS_ERR";
export const DISPLAY_SHARE_POPUP = "DISPLAY_SHARE_POPUP";
export const SET_HEADER_LOGIN = "SET_HEADER_LOGIN";
export const SET_MAINTENANCE = "SET_MAINTENANCE";
export const SHOW_EVENT_POPUP = "SHOW_EVENT_POPUP";
export const SHOW_ROYAL_POPUP = "SHOW_ROYAL_POPUP";
export const SET_EID = "SET_EID";